module.exports = __webpack_public_path__ + "img/brown-purse.36816bf1.jpg";